import React, { useEffect, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import {
    useGetCampaignResponseQuery,
    useGetLandingPageQuery,
    useLazyPostCampaignLandingResponseQuery
} from "../../store/services/simulation-service";
import useLandingTabIdentity from "./useLandingTabIdentity";

const CustomLandingPage = () => {
    const [searchParams] = useSearchParams();
    const identifier = searchParams.get("identifier");

    const [triggerPostLandingResponse] = useLazyPostCampaignLandingResponseQuery();

    const {
        data: campaignData,
        error: campaignError,
        refetch: refetchCampaign
    } = useGetCampaignResponseQuery({ identifier }, { skip: !identifier });

    const { data: landingPageData, error: landingPageError } = useGetLandingPageQuery(
        campaignData?.campaignId,
        { skip: !campaignData?.campaignId }
    );

    useLandingTabIdentity(`${landingPageData?.landingPagePath ?? ""} ${landingPageData?.simulationName ?? ""}`);

    const handleMessage = useCallback(
        async (event) => {
            if (event.data !== "ACTION_LINK_CLICKED") return;
            try {
                await refetchCampaign();
                await triggerPostLandingResponse(identifier);
                setTimeout(() => {
                    window.location.href = `/campaignclicked?identifier=${identifier}&skipMarkFailed=true`;
                }, 3000);
            } catch (error) {
                console.error("Error processing campaign response:", error);
            }
        },
        [identifier, refetchCampaign, triggerPostLandingResponse]
    );

    useEffect(() => {
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    }, [handleMessage]);

    if (campaignError || landingPageError) {
        return <div>Error loading page</div>;
    }

    if (!landingPageData?.landingPagePath) {
        return null;
    }

    return (
        <iframe
            src={landingPageData.landingPagePath}
            style={{
                width: "100vw",
                height: "100vh",
                border: "none",
                overflow: "hidden"
            }}
            title={`custom-landing-${landingPageData?.simulationName ?? ""}`}
        />
    );
};

export default CustomLandingPage;
